import CurrencyPoundRoundedIcon from "@mui/icons-material/CurrencyPoundRounded";

export const currency = (props) => {
  return <CurrencyPoundRoundedIcon {...props} />;
};
